var _defs, _path, _path2, _path3, _g, _g2, _g3, _path4, _path5, _path6, _g4, _g5, _g6;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEmptyStatesIllustrationFirstUse(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 163.341,
    height: 157.011,
    viewBox: "0 0 163.341 157.011",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:none;}.b{fill:url(#a);}.c{fill:#029ce0;}.d{fill:#fff;}.e{fill:#ff6584;}.f{fill:#b3b2d8;}.g,.h,.i{fill:#8282bc;}.h{opacity:0.3;}.i{opacity:0.2;}.j{fill:url(#b);}.k{fill:url(#c);}.l{fill:url(#e);}.m{fill:url(#g);}.n{fill:url(#h);}.o{fill:url(#i);}.p,.r{fill:#c8d3d7;}.p{opacity:0.31;}.q{fill:#72a7d3;opacity:0.29;}.r{opacity:0.11;}.s{opacity:0.15;}.t{clip-path:url(#j);}.u{fill:url(#k);}.v{clip-path:url(#l);}.w{fill:url(#m);}"), /*#__PURE__*/React.createElement("linearGradient", {
    id: "a",
    x1: 0.027,
    y1: 0.386,
    x2: 1.012,
    y2: 0.708,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#f5f9fd"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.155,
    stopColor: "#e7eef8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.444,
    stopColor: "#d2ddf0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.728,
    stopColor: "#c5d3ec"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#c1d0ea"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "b",
    x1: 1.368,
    y1: 0.717,
    x2: -0.409,
    y2: 0.293,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.837,
    stopColor: "#b7c7de"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "c",
    y1: 0.5,
    x2: 1,
    y2: 0.5,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#b7c7de"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "e",
    x1: 1,
    y1: 0.5,
    x2: 0,
    y2: 0.5,
    xlinkHref: "#c"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "g",
    x1: 1,
    y1: 0.5,
    x2: 0,
    y2: 0.5,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#c1d0ea"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "h",
    y1: 0.5,
    x2: 1,
    y2: 0.5,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#b7c7de"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "i",
    x1: 0.315,
    y1: 0.809,
    x2: 0.812,
    y2: -0.019,
    xlinkHref: "#c"
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "j"
  }, /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M118.006,24.432s24.332.216,36.864,19.456c12.715,19.522,20.736,85.247-45.824,108.543S14.839,96.074,11.767,88.413s-28.312-58.689,8.05-80.8C57.658-15.4,60.522,20.758,118.006,24.432Z",
    transform: "translate(-0.384 0)"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "k",
    x1: 0.673,
    y1: 1.292,
    x2: 0.304,
    y2: 0.102,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#f5f9fd"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.092,
    stopColor: "#f0f5fd"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.332,
    stopColor: "#e9f0fc"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#e7effc"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "l"
  }, /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M117.622,25.042s24.332.216,36.864,19.456C167.2,64.02,175.221,129.745,108.662,153.04S14.455,96.684,11.383,89.022s-28.312-58.689,8.05-80.8C57.274-14.791,60.138,21.368,117.622,25.042Z",
    transform: "translate(0 -0.61)"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "m",
    x1: 0.915,
    y1: 0.306,
    x2: -0.006,
    y2: 1.063,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.087,
    stopColor: "#f8fbfe"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.23,
    stopColor: "#f5f9fd"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.249,
    stopColor: "#f4f8fd"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.584,
    stopColor: "#eaf1fc"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#e7effc"
  })))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M117.622,24.432s24.332.216,36.864,19.456c12.715,19.522,20.736,85.247-45.823,108.543S14.455,96.074,11.383,88.413s-28.312-58.689,8.05-80.8C57.274-15.4,60.138,20.758,117.622,24.432Z",
    transform: "translate(0 0)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M47.593,154.712l1.018-.43-1.052-.317-.533-2.2L46.64,154l-1.018.373,1.026.376.469,2.237Z",
    transform: "translate(-21.074 -70.102)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "d",
    d: "M76.039,79.556a.768.768,0,1,1-.768-.768A.768.768,0,0,1,76.039,79.556Z",
    transform: "translate(-34.415 -36.394)"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(150.856 87.452)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "e",
    d: "M280.62,165.688a.258.258,0,0,1-.182-.44l2.645-2.645a.258.258,0,1,1,.364.365l-2.645,2.645A.257.257,0,0,1,280.62,165.688Z",
    transform: "translate(-280.362 -162.527)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "e",
    d: "M283.265,165.688a.257.257,0,0,1-.182-.075l-2.645-2.645a.258.258,0,1,1,.365-.365l2.645,2.645a.258.258,0,0,1-.182.44Z",
    transform: "translate(-280.362 -162.527)"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(13.584 31.161)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M25.5,61.072a.258.258,0,0,1-.182-.44l2.645-2.645a.258.258,0,1,1,.365.365L25.686,61a.257.257,0,0,1-.182.075Z",
    transform: "translate(-25.246 -57.911)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M28.149,61.072A.257.257,0,0,1,27.966,61l-2.645-2.645a.258.258,0,1,1,.365-.365l2.645,2.645a.258.258,0,0,1-.182.44Z",
    transform: "translate(-25.246 -57.911)"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(61.509 28.418)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "g",
    d: "M114.368,55.352a.166.166,0,0,1,.1-.29l2.41-.127a.166.166,0,1,1,.017.332l-2.41.127A.166.166,0,0,1,114.368,55.352Z",
    transform: "translate(-114.313 -53.793)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "g",
    d: "M116.617,55.514a.166.166,0,0,1-.055-.115l-.127-2.41a.166.166,0,0,1,.332-.017l.127,2.41a.166.166,0,0,1-.277.132Z",
    transform: "translate(-115.293 -52.813)"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(0.282 0.282)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "g",
    d: "M114.838,53.788a.166.166,0,0,1,.273-.141l1.846,1.556a.166.166,0,0,1-.214.254L114.9,53.9a.166.166,0,0,1-.058-.113Z",
    transform: "translate(-114.838 -53.462)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "g",
    d: "M115.108,55.364a.166.166,0,0,1,.039-.121L116.7,53.4a.166.166,0,1,1,.254.214L115.4,55.457a.166.166,0,0,1-.293-.093Z",
    transform: "translate(-114.962 -53.338)"
  })))), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "d",
    d: "M242.867,97.67l1.621-.684-1.676-.505-.848-3.509-.615,3.565-1.62.593,1.633.6.746,3.56Z",
    transform: "translate(-110.736 -42.946)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "e",
    d: "M65.779,136.073a1.314,1.314,0,1,1-1.314-1.314,1.314,1.314,0,0,1,1.314,1.314Z",
    transform: "translate(-29.17 -62.248)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "h",
    d: "M136.945,167.5l-14.876,31.342h46.024L153.051,167.5Z",
    transform: "translate(-56.387 -77.373)"
  })), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(62.567 8.149)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "i",
    d: "M163.079,178.166l-5.258,5.566a1.865,1.865,0,0,1-2.705.006l-5.3-5.559a9.791,9.791,0,0,1-2.718-9.35l.569-1.705,2.058-6.161h13.4l2.065,6.192.569,1.706A9.776,9.776,0,0,1,163.079,178.166Z",
    transform: "translate(-130.376 -82.502)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "h",
    d: "M165.535,164.5a5.7,5.7,0,0,1-1.2,5.707l-.027.029-5.3,5.612a1.8,1.8,0,0,1-2.617.006l-5.346-5.606-.028-.029a5.644,5.644,0,0,1-1.261-5.675l1.2-3.586h13.4Z",
    transform: "translate(-131.61 -82.502)"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 53.958)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "j",
    d: "M187.657,132.611,199.739,148.2a.9.9,0,0,0,1.609-.551v-19a5.389,5.389,0,0,0-2.094-4.264l-11.6-8.962Z",
    transform: "translate(-149.25 -115.425)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "k",
    d: "M129.971,132.611,117.887,148.2a.9.9,0,0,1-1.607-.55v-19a5.392,5.392,0,0,1,2.1-4.267l11.6-8.961Z",
    transform: "translate(-116.28 -115.425)"
  })), /*#__PURE__*/React.createElement("path", {
    className: "k",
    d: "M164.43,52.627q-.311-.967-.648-1.909c-.448-1.256-.927-2.478-1.427-3.663-.625-1.481-1.284-2.9-1.96-4.26q-.638-1.281-1.292-2.48H139.826q-.652,1.2-1.292,2.48c-.676,1.357-1.335,2.779-1.96,4.26-.5,1.185-.979,2.407-1.427,3.663q-.336.942-.648,1.909A54.743,54.743,0,0,0,131.727,69.4a102.016,102.016,0,0,0,.645,11.554c.233,2.043.527,4.024.876,5.933q.1.573.216,1.136.2,1,.418,1.976c.1.445.2.887.308,1.322q.261,1.07.546,2.1.142.515.291,1.019.3,1.008.616,1.973T136.3,98.3q.512,1.376,1.071,2.642.745,1.686,1.567,3.16h21.044q.82-1.471,1.566-3.16c.62-1.4,1.2-2.917,1.732-4.523q.32-.964.617-1.973.148-.5.291-1.019.285-1.03.546-2.1.391-1.605.726-3.3.111-.563.216-1.136c.349-1.909.643-3.89.876-5.933A102.048,102.048,0,0,0,167.2,69.4a54.74,54.74,0,0,0-2.772-16.775Z",
    transform: "translate(-123.415 -26.771)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "e",
    d: "M164.455,25.874q-.207-.348-.413-.686-.618-1.016-1.222-1.947c-1.738-2.689-3.339-4.829-4.505-6.3-.488-.614-.9-1.111-1.214-1.481a.9.9,0,0,0-1.369,0c-.314.37-.726.866-1.214,1.481-1.166,1.468-2.767,3.609-4.505,6.3q-.6.931-1.222,1.947-.206.339-.413.686-.414.7-.83,1.427-.386.678-.77,1.386h19.277C165.523,27.708,164.987,26.768,164.455,25.874Z",
    transform: "translate(-130.368 -15.145)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "l",
    d: "M154.607,154.376H142.859q.59,1.269,1.225,2.41h21.044q.635-1.139,1.225-2.41Z",
    transform: "translate(-128.557 -79.459)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "l",
    d: "M164.374,158.552H143.33l-2.1,5.354h25.252Z",
    transform: "translate(-127.803 -81.388)"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(14.329 26.71)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "m",
    d: "M154.63,64.785a11.72,11.72,0,1,0,11.72,11.72,11.72,11.72,0,0,0-11.72-11.72Z",
    transform: "translate(-142.91 -64.785)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M166.085,78.11a9.851,9.851,0,0,0-19.7,0h0a9.851,9.851,0,1,0,19.7,0",
    transform: "translate(-144.514 -66.39)"
  })), /*#__PURE__*/React.createElement("path", {
    className: "n",
    d: "M165.365,137.213v8a3.269,3.269,0,0,1-.484,1.714,39.879,39.879,0,0,1-2.578,3.756,2.275,2.275,0,0,1-3.719,0,34.389,34.389,0,0,1-2.474-3.778,3.28,3.28,0,0,1-.438-1.637V137a1.93,1.93,0,0,1,.1-.6l4.066-12.423.692-2.116.094-.287.716,2.4,3.941,12.657A1.931,1.931,0,0,1,165.365,137.213Z",
    transform: "translate(-134.476 -64.309)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "o",
    d: "M155.89,75.571c-.393-.926-1.562-.891-2.7.324s-1.544,2.348-.926,2.835c.836.66,1.571.6,2.59-.723C155.482,77.188,156.3,76.547,155.89,75.571Z",
    transform: "translate(-132.768 -42.758)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "p",
    d: "M173.036,91l.37.1-.221-.31.321-.717-.581.532-.358-.114.2.321-.346.712Z",
    transform: "translate(-142.214 -49.757)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "q",
    d: "M173.456,95.46a.188.188,0,1,1-.188-.188A.188.188,0,0,1,173.456,95.46Z",
    transform: "translate(-142.517 -52.158)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M163.889,82.4a.209.209,0,1,1-.209-.209A.209.209,0,0,1,163.889,82.4Z",
    transform: "translate(-138.078 -46.116)"
  }), /*#__PURE__*/React.createElement("g", {
    className: "s",
    transform: "translate(23.527 42.971)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "d",
    d: "M160.132,96.575a.128.128,0,0,1-.091-.218l1.313-1.313a.128.128,0,1,1,.181.181l-1.313,1.313A.128.128,0,0,1,160.132,96.575Z",
    transform: "translate(-160.004 -95.006)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "d",
    d: "M161.446,96.575a.127.127,0,0,1-.091-.037l-1.313-1.313a.128.128,0,0,1,.181-.181l1.313,1.313a.128.128,0,0,1-.09.218Z",
    transform: "translate(-160.004 -95.006)"
  })), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M173.178,80.988l.712.189-.426-.6.619-1.379-1.118,1.023-.689-.218.387.617L172,81.993Z",
    transform: "translate(-142.018 -44.734)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M153.315,89.2l.391.1-.233-.328.34-.758-.614.562-.378-.121.213.339-.366.753Z",
    transform: "translate(-133.088 -48.899)"
  }))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    className: "t",
    transform: "translate(0.207 0)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "u",
    d: "M179.659,249.609l-96.2,3.01c.114-.78,2.765-22.751,3.051-23.483.235-.691.45-1.384.722-2.068a10.371,10.371,0,0,1,1.387-2.369,8.163,8.163,0,0,1,3.821-2.813,7.256,7.256,0,0,1,1.854-.4,18.351,18.351,0,0,1,.651-2.012,11.575,11.575,0,0,1,6.717-6.6,16.054,16.054,0,0,1,7.276-.411,16.616,16.616,0,0,1,2.72.55,7.852,7.852,0,0,1,3.043-3.99c2.424-1.592,5.68-1.515,8.3-.66a11.109,11.109,0,0,1,2.433,1.141,24.767,24.767,0,0,1,2.933-3.648,18.361,18.361,0,0,1,5.366-3.768,13.483,13.483,0,0,1,12.322.9,13.238,13.238,0,0,1,4.662,4.819c.288-.085.58-.162.879-.222a12.7,12.7,0,0,1,9.752,2,17.813,17.813,0,0,1,5.741,6.778,12.089,12.089,0,0,1,7.517,2.037,12.728,12.728,0,0,1,5.1,12.563C179.69,231.09,179.685,249.475,179.659,249.609Z",
    transform: "translate(-38.759 -92.842)"
  }))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    className: "v",
    transform: "translate(0 0.328)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "w",
    d: "M70.532,252.481l89.639-1.433c-.108-.734-1.184-19.362-1.454-20.051-.222-.65-.426-1.3-.684-1.947a9.748,9.748,0,0,0-1.313-2.23,7.728,7.728,0,0,0-3.619-2.648,6.911,6.911,0,0,0-1.756-.374,17.182,17.182,0,0,0-.617-1.893,10.931,10.931,0,0,0-6.362-6.215,15.3,15.3,0,0,0-6.891-.387,15.831,15.831,0,0,0-2.576.518,7.4,7.4,0,0,0-2.882-3.756c-2.3-1.5-5.38-1.426-7.862-.621a10.554,10.554,0,0,0-2.3,1.074,23.335,23.335,0,0,0-2.778-3.434,17.391,17.391,0,0,0-5.083-3.546,12.839,12.839,0,0,0-11.67.842,12.5,12.5,0,0,0-4.415,4.536c-.273-.08-.549-.152-.832-.209a12.088,12.088,0,0,0-9.236,1.878,16.794,16.794,0,0,0-5.437,6.379,11.5,11.5,0,0,0-7.119,1.917,11.945,11.945,0,0,0-4.834,11.824C70.465,232.837,70.507,252.355,70.532,252.481Z",
    transform: "translate(-32.473 -94.794)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmptyStatesIllustrationFirstUse);
export default __webpack_public_path__ + "static/media/empty-states_illustration_first-use.c0f5bb81b170614740450487939bcb50.svg";
export { ForwardRef as ReactComponent };